import React, { Component } from 'react';
import { connect } from 'react-redux';
import Snackbar from 'material-ui/Snackbar';
import RaisedButton from 'material-ui/RaisedButton';
import { clearLastErrorMessage } from '../actions';

class ErrorSnackBar extends Component {

  handleRequestClose = () => {
    this.props.dispatch(clearLastErrorMessage());
  };

  render() {
    if (!this.props.displayError) return <span></span>;
    return (
      <Snackbar
          open={true}
          message={this.props.error.get('message')}
          autoHideDuration={this.props.error.get('autoHideDuration') || 4000}
          onRequestClose={this.handleRequestClose}
        />
    );
  }
}

function mapStateToProps(state) {
  return {
    error: state.get('errors').first(),
    displayError: state.get('errors').size > 0,
  };
}

export default connect(mapStateToProps)(ErrorSnackBar);



/** WEBPACK FOOTER **
 ** ./containers/ErrorSnackBar.js
 **/